
import MainUI from "./components/MainUI.vue";

export default {
	components: {
		MainUI,
	},
};
